import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import airbnb from 'src/App/assets/airbnb.svg';
import BedIcon from '@mui/icons-material/Bed';
import BathtubOutlinedIcon from '@mui/icons-material/BathtubOutlined';
import { COLOR_BACKGROUND_2, COLOR_GREY_200 } from 'src/colors';
import {
  getProcessedDataForDynamicPricing,
  getnextNDates,
  processListingLevelData,
  processMarketLevelData,
} from 'src/utils/functions';
import ManageListingModal from '../../Modals/ManageListingModal';

const d3 = require('d3');

const UserAirbnbListingPage = ({ data, showUserListingsFetchingMiniLoader }) => {
  const [showManageListingModal, setShowManageListingModal] = useState<Boolean>(false);
  const [
    listingPricingRecommendationDataForManageListing,
    setListingPricingRecommendationDataForManageListing,
  ] = useState();
  const [sortBy, setSortBy] = useState('revPARDiff');
  const [searchId, setSearchId] = useState('');

  const handleSearchId = event => {
    setSearchId(event.target.value);
  };

  const handleSortByChange = event => {
    setSortBy(event.target.value);
  };

  const handleManageListingButtonClick = data => {
    setShowManageListingModal(true);
    setListingPricingRecommendationDataForManageListing(data.listingPricingRecommendation);
  };

  let processData = getProcessedDataForDynamicPricing(data, 30, sortBy, [], searchId);
  // console.log('processData', processData);
  // console.log('searchId', searchId);
  
  const getFormattedName = (unformattedName) =>{
    let formattedName = unformattedName.replace(/\+/g, ' ');
    return formattedName;
  }

  return (
    <>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: 500, marginBottom: '10px', display: 'flex', alignItems: 'baseline' }}
          >
            Your Listings{' '}
            {showUserListingsFetchingMiniLoader && (
              <Typography variant="body1" sx={{ marginLeft: '10px' }}>
                <CircularProgress size="20px" sx={{ marginRight: '10px' }} />
                Still fetching your listings
              </Typography>
            )}
          </Typography>

          <Box sx={{ display: 'flex' }}>
            <Typography
              variant="h5"
              sx={{ fontWeight: 500, marginBottom: '10px', marginRight: '5px', marginTop: '5px' }}
            >
              Sort By:
            </Typography>
            <FormControl>
              <Select
                value={sortBy}
                onChange={handleSortByChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                sx={{
                  width: '150px',
                  '& .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
                    padding: '10px',
                  },
                }}
              >
                <MenuItem value={'revPARDiff'}>RevPAR</MenuItem>
                <MenuItem value={'occupancyDiff'}>Occupancy</MenuItem>
                <MenuItem value={'bookedRateDiff'}>Booked Rates</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
        {processData.length > 20 && <Box sx={{ display: 'flex', margin: '0px 0px 10px 5px', alignItems:'baseline' }}>
          <Typography variant="h6">ListingID:</Typography>
          <TextField
            hiddenLabel
            id="filled-hidden-label-small"
            size="small"
            sx={{ marginLeft: '5px' }}
            onChange={handleSearchId}
          />
        </Box>}
        {showManageListingModal && (
          <ManageListingModal
            open={showManageListingModal}
            onClose={() => setShowManageListingModal(false)}
            listingPricingRecommendation={listingPricingRecommendationDataForManageListing}
          />
        )}
        {processData.map(listingData => (
          <Grid
            container
            sx={{
              height: '255px',
              width: '100%',
              marginBottom: '15px',
              border: '1px solid lightgrey',
              backgroundColor: COLOR_BACKGROUND_2,
              borderRadius: '10px',
              boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            }}
          >
            <Grid item xs={3} sm={3} md={3}>
              <Box
                sx={{
                  padding: '10px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: '500', width: '100%' ,maxHeight:'45px', overflow:'hidden', textOverflow:'ellipsis'}}>
                  {getFormattedName(listingData.name)}
                </Typography>
                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'end' }}>
                  <Box sx={{ display: 'flex' }}>
                    <BedIcon />
                    <Typography
                      variant="h6"
                      sx={{
                        margin: '2px',
                        fontSize: '13px',
                      }}
                    >
                      {listingData.bedrooms}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex' }}>
                    <BathtubOutlinedIcon />
                    <Typography
                      variant="h6"
                      sx={{
                        margin: '2px',
                        fontSize: '13px',
                      }}
                    >
                      {listingData.bathrooms}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ position: 'relative', minHeight: '150px', width: '100%' }}>
                  <img
                    src={listingData.thumbnail_url}
                    style={{
                      objectFit: 'cover',
                      width: '100%',
                      height: '150px',
                      borderRadius: '10px',
                    }}
                    alt={listingData.name}
                  />
                  <div
                    style={{
                      background: '#fff',
                      padding: '5px 15px',
                      borderRadius: 100,
                      position: 'absolute',
                      top: '10px',
                      left: '10px',
                      zIndex: 1,
                    }}
                  >
                    <img src={airbnb} style={{ height: '15px', marginTop: '5px' }} />
                  </div>
                  <Button
                    onClick={() => handleManageListingButtonClick(listingData)}
                    sx={{
                      position: 'absolute',
                      bottom: '-15px',
                      left: '20%',
                      padding: '2px 10px',
                      backgroundColor: 'black',
                      color: 'white',
                      borderRadius: '10px',
                      ':hover': {
                        backgroundColor: '#616161',
                      },
                    }}
                  >
                    Manage Listing
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={9} sm={9} md={9}>
              <Box
                sx={{
                  backgroundColor: COLOR_GREY_200,
                  height: '100%',
                  width: '100%',
                  borderRadius: '0px 10px 10px 0px',
                }}
              >
                <Typography variant="h5" sx={{ padding: '20px 0px 0px 20px' }}>
                  Next 30 Days
                </Typography>
                <Grid
                  container
                  sx={{
                    marginTop: '20px',
                    padding: '0px 25px',
                  }}
                >
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>
                      Comparison
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>
                      Occupancy
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>
                      Booked Rates
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>
                      RevPAR
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={{
                    marginTop: '20px',
                    padding: '0px 25px',
                  }}
                >
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>
                      Listing Average
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: '500',
                        color: `${
                          Number(listingData.listingOccupancy) >
                          Number(listingData.compsMedianOccupancy)
                            ? 'green'
                            : 'red'
                        }`,
                      }}
                    >
                      {listingData.listingOccupancy}%
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: '500',
                        color: `${
                          Number(listingData.listingBookingRate) >
                          Number(listingData.compsMedianBookingRate)
                            ? 'green'
                            : 'red'
                        }`,
                      }}
                    >
                      ${listingData.listingBookingRate}
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: '500',
                        color: `${
                          Number(listingData.listingRevPAR) > Number(listingData.compsMedianRevPAR)
                            ? 'green'
                            : 'red'
                        }`,
                      }}
                    >
                      ${listingData.listingRevPAR}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={{
                    marginTop: '20px',
                    padding: '0px 25px',
                  }}
                >
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>
                      Comps Average
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>
                      {listingData.compsMedianOccupancy}%
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>
                      ${listingData.compsMedianBookingRate}
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>
                      ${listingData.compsMedianRevPAR}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        ))}
      </Box>
    </>
  );
};

export default UserAirbnbListingPage;
